// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-TB8","top":"styles_top__14h_l"};